import React from 'react';

class Jumbotron extends React.Component{

    static defaultProps = {
        heading: "Hello There",
        content: "This is a big jumbotron (hero) element. Put something you there that you really want stand out! All Bootstrap Components like this are made available as React Components.",
        className: "",
        action: null
    };
    
    render(){
        const { heading, content, className, action } = this.props;
        return (
            <div className={'jumbotron '+className}>
                <h1 className="display-4">{heading}</h1>
                <p className="lead">{content}</p>
                {action}
            </div>
        );
    }
}

export default Jumbotron;
